<ng-closet-doors-custom-environment *ngIf="step === 1"></ng-closet-doors-custom-environment>
<ng-closet-doors-custom-closet-configuration *ngIf="step === 2"></ng-closet-doors-custom-closet-configuration>
<ng-closet-doors-custom-suppliers *ngIf="step === 3"></ng-closet-doors-custom-suppliers>
<ng-closet-doors-custom-finishes *ngIf="step === 4"></ng-closet-doors-custom-finishes>
<ng-closet-doors-custom-accessories *ngIf="step === 5"></ng-closet-doors-custom-accessories>
<ng-closet-doors-custom-summary *ngIf="step === 6"></ng-closet-doors-custom-summary>
